import { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FiCheck, FiCopy, FiExternalLink } from 'react-icons/fi';

export default function PublicLinkCard({ url }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Card className="px-5 py-5">
      <p className="mb-1 text-xs font-semibold uppercase tracking-wide text-neutral">Link público</p>
      <div className="mb-4 rounded-md border border-primary-lightest bg-neutral-bright px-3 py-2">
        <span className="select-all break-all font-mono text-xs text-neutral-dark">{url}</span>
      </div>
      <div className="flex items-center gap-2">
        <Button
          size="sm"
          onClick={handleCopy}
        >
          {copied ? <FiCheck /> : <FiCopy />}
          {copied ? 'Copiado!' : 'Copiar link'}
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => window.open(url, '_blank')}
        >
          <FiExternalLink />
          Abrir
        </Button>
      </div>
    </Card>
  );
}
